// TEXT
import styled from "styled-components";
import { primary01, primary03 } from "../../../styles/tokens";
import { Size } from "../Toggle.Parts";

// STYLES
export const Icon = styled.svg<{ $size: Size }>`
  width: ${({ $size }) =>
    $size === "small"
      ? "0.5rem"
      : $size === "xsmall"
        ? "0.425rem"
        : "0.625rem"};
  height: ${({ $size }) =>
    $size === "small"
      ? "0.4375rem"
      : $size === "xsmall"
        ? "0.425rem"
        : "0.5625rem"};
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 100ms;
  color: ${primary01};

  [data-state="checked"] & {
    opacity: 1;
  }

  [data-disabled] & {
    color: ${primary03};
  }
`;

// DATA

// TYPES
export type Props = {
  size: Size;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
